/* template */
<template><div class="didi-mall-toast"><div :class='("didi-mall-toast_icon "+(icon ? icon : ""))'></div><div class="didi-mall-toast_text">{{content}}</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mac0d13f0"}'>
.didi-mall-toast
  position fixed
  width 300rpx
  height 240rpx
  top 50%
  left 50%
  transform translate(-50%, -50%)
  display flex
  flex-flow column
  justify-content center
  align-items center
  padding 20rpx
  background rgba(20,20,20,0.7)
  border-radius 5px
  box-sizing border-box
  z-index 1100
  .didi-mall-toast_icon
    width 80rpx
    height 80rpx
    background url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTczMDE0ODkyMTM3IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjY1OTAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTEyMi4yODA5NiA1MzYuNjIzMTA0Yy05Ljk0MDk5Mi05LjkyNTYzMi0xMS41NDg2NzItMjUuMzYwMzg0LTIuNzg1MjgtMzYuNDA3Mjk2bDIwLjQ4NzE2OC0yNS44MjgzNTJjOC4zOTc4MjQtMTAuNTg4MTYgMjQuMTA4MDMyLTEzLjI0NjQ2NCAzNS4yMTEyNjQtNS44MzU3NzZsMTc3LjMzMTIgMTE4LjM1OTA0YzkuMzUzMjE2IDYuMjQzMzI4IDI1LjQ1MjU0NCA1LjQzMDI3MiAzNC4xODUyMTYtMS42NTQ3ODRsNDY4LjU4MjQtMzgwLjE2YzEwLjUzMjg2NC04LjU0NTI4IDI3LjAzMDUyOC03LjgxNzIxNiAzNi4yNjE4ODggMS40MDA4MzJsMTEuNTQyNTI4IDExLjUyNTEyYzEwLjA0NTQ0IDEwLjAzMDA4IDkuMzE0MzA0IDI1Ljk1MTIzMi0xLjIxNTQ4OCAzNi40NjU2NjRsLTUwMi45MjczNiA1MDIuMTgzOTM2Yy0xNS42NDY3MiAxNS42MjQxOTItNDEuMzM3ODU2IDE0Ljk0MDE2LTU3LjQ0NTM3Ni0xLjE0Mjc4NGwtMjE5LjIyODE2LTIxOC45MDU2eiIgZmlsbD0iI2ZmZmZmZiIgcC1pZD0iNjU5MSI+PC9wYXRoPjwvc3ZnPg==') no-repeat
    background-size cover
    &.warning
      background-image url('https://dpubstatic.udache.com/static/dpubimg/44aabe81-cef9-4063-852a-0731c07ea0b7.png')
    &.error
      background-image url('https://dpubstatic.udache.com/static/dpubimg/-IXPe77X56/toast_icon_wrong.png')
  .didi-mall-toast_text
    font-family PingFangSC-Medium
    font-size 24rpx
    color #FFFFFF
    margin-top 12rpx
    text-align center
    white-space: pre;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mac0d13f0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./toast.mpx.js?isComponent&outputPath=components%2Ftoastac0d13f0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./toast.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftoastac0d13f0%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mac0d13f0"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/toastac0d13f0/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
